<template>
  <header class="user-header">
    <div v-if="shouldShowBackButton" class="profile-button" @click="goToProfile">
      <span>←返回面试</span>
    </div>

    
    <!-- 右上角：头像登录按钮 -->
    <div class="user-info" @click="handleUserClick" v-click-outside="closeUserMenu">
      <div class="avatar-container">
        <img v-if="displayAvatar && displayAvatar !== require('./assets/img/avatar.png')" :src="displayAvatar" class="avatar" alt="avatar" referrerpolicy="no-referrer" />
        <div v-else class="avatar-placeholder">{{ displayGreeting.charAt(0) === 'H' ? 'U' : displayGreeting.charAt(0) }}</div>
      </div>
      <span class="text">{{ displayGreeting }}</span>
      
      <!-- 用户下拉菜单 -->
      <transition name="fade">
        <div v-if="showUserMenu" class="user-dropdown-menu">
          <!-- 导航菜单项 -->
          <div v-for="it in menuList" :key="it.name" class="menu-item" @click="handleMenuSelect(it)">
            <img class="icon-left" :src="it.icon" alt="" />
            <span class="txt">{{ it.name }}</span>
          </div>
          
          <!-- 用户操作项 -->
          <template v-if="isLoggedIn">
            <div class="menu-item" @click="logout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </div>
          </template>
        </div>
      </transition>
    </div>

    <!-- 意见反馈弹窗 -->
    <FeedbackDialog :visible="feedbackDialogVisible" :question="question" @cancel="closeFeedbackDialog" @submit="handleFeedbackSubmit" />
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getToken } from '@/store/local/auth'
import FeedbackDialog from '@/components/FeedbackDialog/index.vue'
import { submitFeedback } from '@/api/user'
import { DEFAULT_AVATAR } from '@/constants/avatar'

export default {
  components: {
    FeedbackDialog
  },
  name: 'UserHeader',
  props: {
    avatarUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showUserMenu: false,
      menuList: [
        { name: '返回首页', icon: require('./assets/img/ic-home.png') },
        { name: '个人中心', icon: require('./assets/img/ic-user.png') },
        { name: '消息提醒', icon: require('./assets/img/ic-notice.png') },
        { name: '面试记录', icon: require('./assets/img/ic-interview.png') },
        { name: '简历管理', icon: require('./assets/img/ic-resume.png') },
        { name: '机会获取', icon: require('./assets/img/ic-opportunity.png') },
        { name: '意见反馈', icon: require('./assets/img/ic-yjfk.png') }
      ],
      // 从 localStorage 读取到的用户信息
      localUser: {
        name: '',
        avatar: ''
      },
      // 意见反馈弹窗状态
      feedbackDialogVisible: false,
      question: '您对我们的服务有什么建议吗？',
      // 需要显示返回面试按钮的路由
      backButtonRoutes: [
        '/store/personal',  // 个人中心模块（包括所有子路由）
        '/interview_mianshilishi',  // 面试记录
        '/Interview_Analysis',
        '/store/Interview_Analysis',
      ],
      backHotPost: [
        '/chating'
      ]
    }
  },
  computed: {
    ...mapState('user', ['name', 'avatar']),
    isLoggedIn() {
      // 检查是否有token或用户信息来判断登录状态
      const token = getToken()
      const hasUserInfo = this.localUser.name || this.name
      return !!(token && hasUserInfo)
    },
    displayAvatar() {
      // 优先 localStorage，其次全局用户头像，再其次 prop，最后默认头像
      const avatar = (
        this.localUser.avatar ||
        this.avatar ||
        this.avatarUrl ||
        require('./assets/img/avatar.png')
      )
      // 如果头像是 /adminapi/static/default_avatar.png，则使用默认头像
      if (avatar === '/adminapi/static/default_avatar.png') {
        return DEFAULT_AVATAR
      }
      return avatar
    },
    displayGreeting() {
      
      const n = this.localUser.name || this.name
      return n ? `Hi, ${n}!` : 'Hi, 请登录'
    },
    shouldShowBackButton() {
      const currentPath = this.$route.path
      // 检查当前路由是否在需要显示返回面试按钮的路由数组中
      return this.backButtonRoutes.some(route => {
        // 如果是个人中心模块或面试分析页面，需要检查是否以该路径开头（包含子路由）
        if (route === '/store/personal' || route === '/Interview_Analysis') {
          return currentPath.startsWith(route)
        }
        // 其他路由使用精确匹配
        return currentPath === route
      })
    },
  },
  created() {
    // 若存在 token 且还未加载到用户信息，则尝试拉取
    const token = getToken()
    // 先尝试从 localStorage 获取
    try {
      const raw = window.localStorage.getItem('userInfo')
      if (raw) {
        const info = JSON.parse(raw)
        const candidateName = info.real_name || info.nickname  || info.account || info.mobile || ''
        this.localUser = {
          name: candidateName,
          avatar: info.avatar || ''
        }
      }
    } catch (e) {
      // ignore
    }
    if (token && (!this.name || !this.avatar)) {
      this.fetchUserInfoSafely()
    }
  },
  mounted() {
    // 监听其他标签页对 localStorage 的更新
    window.addEventListener('storage', this.handleStorageChange)
    
    // 添加点击外部关闭用户菜单的事件监听器
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange)
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ...mapActions('user', ['getInfo']),
    goToProfile() {
      this.$router.push('/store/dashboard/profile')
    },
    async fetchUserInfoSafely() {
      try {
        await this.getInfo()
      } catch (e) {
        // 静默失败，维持默认显示
      }
    },
    handleLoginTrigger() {
      // 未登录则跳转到登录页；已登录则前往个人资料
      const token = getToken()
      if (!token) {
        this.$router.push('/store/entry/loginPwd')
        return
      }
      this.$router.push('/store/dashboard/profile')
    },
    handleStorageChange(e) {
      if (e.key === 'userInfo') {
        try {
          const info = e.newValue ? JSON.parse(e.newValue) : null
          const candidateName = info && (info.nickname || info.real_name || info.account || info.mobile || '')
          this.localUser = info
            ? { name: candidateName, avatar: info.avatar || '' }
            : { name: '', avatar: '' }
        } catch (_) {}
      }
    },
    closeUserMenu() {
      this.showUserMenu = false
    },
    handleMenuSelect(item) {
      const name = item && item.name
      switch (name) {
        case '返回首页':
          this.$router.push('/')
          break
        case '个人中心':
        this.$router.push('/store/personal/basic');
          break
        case '消息提醒':
          this.$router.push('/chating')
          break
        case '面试记录':
          this.$router.push('/interview_mianshilishi')
          break
        case '简历管理':
          // this.$router.push('/resume_manage')
          this.$router.push('/store/personal/resume')
          break
        case '机会获取':
          this.$router.push('/qzpp')
          break
        case '意见反馈':
          this.feedbackDialogVisible = true
          break
        default:
          break
      }
      this.$emit('menu-select', item)
      this.closeUserMenu()
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$message.success('已成功退出登录');
        this.$router.push('/store/entry');
      }).catch(error => {
        console.error('退出登录失败:', error);
        this.$message.error('退出登录失败，请重试');
      });
    },
    handleUserClick() {
      // 切换菜单显示
      this.toggleUserMenu();
    },
    handleClickOutside(event) {
      // 检查点击是否在用户信息区域外
      const userInfo = this.$el.querySelector('.user-info');
      if (userInfo && !userInfo.contains(event.target)) {
        this.showUserMenu = false;
      }
    },
    closeFeedbackDialog() {
      this.feedbackDialogVisible = false
    },
    async handleFeedbackSubmit(data) {
      if (!data.feedbackText || !data.feedbackText.trim()) {
        this.$message.warning('请输入反馈内容');
        return;
      }
      
      try {
        // 调用反馈提交API
        await submitFeedback({
          emojiIndex: data.emojiIndex,
          feedbackText: data.feedbackText
        });
        this.feedbackDialogVisible = false;
      } catch (error) {
        this.$message.error('提交反馈失败，请稍后重试');
      }
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value()
        }
        document.addEventListener('click', el.clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutside)
      }
    }
  }
}
</script>

<style scoped>
.user-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  z-index: 9999;
  pointer-events: none;
  background: transparent;
}

.profile-button {
  position: absolute;
  top: 15px;
  left: calc(50% - 700px);
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 43px;
  padding: 0 15px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.profile-button:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.profile-button i {
  font-size: 18px;
  color: #1d1d1f;
}

.profile-button span {
  font-size: 15px;
  font-weight: 500;
  color: #1d1d1f;
}

.user-info {
  position: absolute;
  top: 15px;
  right: calc(50% - 670px);
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 5px;
  height: 43px;
  padding: 0 15px 0 5px;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #e5e5e5;
  border-radius: 22px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.user-info:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.avatar-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.text {
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
}


.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .12);
  min-width: 180px;
  z-index: 1001;
  margin-top: 8px;
  max-height: 400px;
  overflow-y: auto;
}

.user-dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #e4e7ed;
}

.user-dropdown-menu::after {
  content: '';
  position: absolute;
  top: -5px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 14px;
  color: #333;
}

.menu-item:hover .txt {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.menu-item:hover .icon-left {
  filter: hue-rotate(200deg) saturate(1.5) brightness(1.2);
}

.menu-item:hover i {
  color: #77BAFF;
}

.menu-item i {
  font-size: 16px;
  color: #666;
}

.menu-item:first-child {
  border-radius: 10px 10px 0 0;
}

.menu-item:last-child {
  border-radius: 0 0 10px 10px;
}

.menu-divider {
  height: 1px;
  background-color: #e4e7ed;
  margin: 4px 0;
}

.icon-left {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.txt {
  flex: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .16s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>